import { toISODate } from "@calendar/weekDates";

/** `YYYY-MM-DD`: lexicographic order is chronological. */
type DayKey = string;

/**
 * Must match brian's clinic-day windowing (`clock.day_bounds_utc`); browser-local
 * when the timezone is missing or unknown.
 */
export const clinicDayKey = (
  at: string | number | Date,
  timeZone?: string,
): DayKey => {
  const instant = typeof at === "string" ? new Date(at) : at;
  try {
    // en-CA formats as YYYY-MM-DD.
    return new Intl.DateTimeFormat("en-CA", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(instant);
  } catch {
    return toISODate(new Date(instant));
  }
};
